import { NavLink, Outlet } from 'react-router';
import { cn } from '../lib/cn';
import { useDrainOutboxOnReconnect } from '../lib/use-drain-outbox';

// Persistent shell for the data-routed app. Keeps the DESIGN §2.1 IA
// intact as a single top nav; the NavLink active state uses the accent
// pill so the user always knows which screen they're on.
type NavItem = { readonly to: string; readonly label: string; readonly end?: boolean };

const NAV: readonly NavItem[] = [
  { to: '/', label: 'Today', end: true },
  { to: '/add', label: 'Add' },
  { to: '/history', label: 'History' },
  { to: '/goals', label: 'Goals' },
  { to: '/settings', label: 'Settings' },
  { to: '/agents', label: 'Agents' },
];

export default function RootLayout(): React.JSX.Element {
  useDrainOutboxOnReconnect();
  return (
    <div className="min-h-screen bg-[var(--color-base)] text-[var(--color-ink)]">
      <header className="border-b border-[var(--color-border)] bg-[var(--color-base)]/85 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-6 px-6 py-4">
          <NavLink to="/" className="heading text-2xl tracking-tight" end>
            Food Diary
          </NavLink>
          <nav aria-label="Primary" className="flex gap-1 text-sm">
            {NAV.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end ?? false}
                className={({ isActive }) =>
                  cn(
                    'rounded-full px-3 py-1.5 font-medium text-[var(--color-ink-muted)] hover:text-[var(--color-ink)]',
                    isActive && 'bg-[var(--color-accent-soft)] text-[var(--color-accent)]',
                  )
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-6 py-10">
        <Outlet />
      </main>
    </div>
  );
}
